import { FamilyIcon } from '@repo/ui/icons'

import UserNavBar from '../../../components/elements/nav-bar'
import { HostFamilyTable } from '../../../components/pages/ols/host-family/host-family-table'

const OLHostFamilyGlobalListPage = () => {
  return (
    <div>
      <UserNavBar title={'Liste des familles-hôtesses'} icon={FamilyIcon} />
      <div className="h-4" />
      <HostFamilyTable mode="global" />
    </div>
  )
}

export default OLHostFamilyGlobalListPage
